<template>
    <b-card title="View System Promo">
        <b-col cols="12">
            <label>Name</label>
            <b-form-input placeholder="Project Name" v-model="systemPromo.name" disabled></b-form-input>
        </b-col>

        <b-col cols="12">
            <label>Compressor (Unit) >=</label>
            <b-form-input placeholder="Extend Month" v-model="systemPromo.compressor" disabled></b-form-input>
        </b-col>

        <b-col cols="12">
            <label>Fan Coil (Unit) >=</label>
            <b-form-input placeholder="Extend Month" v-model="systemPromo.fanCoil" disabled></b-form-input>
        </b-col>

        <b-col cols="12" class="my-1">
        <b-form-group
              label="List of Valid Model Under Promotion"
              description="Please make sure for each row have only one Model"
            >
        <b-form-textarea
            disabled
            rows="6"
            max-rows="8"
            no-auto-shrink
            v-model="systemPromo.models"></b-form-textarea>
        </b-form-group>
        </b-col>

        <b-col cols="12" class="mt-2">
            <b-button variant="secondary" @click="$router.go(-1)">Back</b-button>
        </b-col>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            systemPromo: {},
        }
    },
    mounted() {
        this.getSystemPromo().then((data) => {
            this.systemPromo = data[0];
            if(data[0].models) {
                let convert = data[0].models.toString().replace(/,/g,'\n')
                this.systemPromo.models = convert;
            }
        })
    },
    methods: {
        ...mapActions({
            getSystemPromo: 'systemPromo/getSystemPromo'
        })
    }
}
</script>